module.exports = __webpack_public_path__ + "img/car-C-1.0439cf14.jpg";